import Panel from './panel';
import Stage from './stage';
// import Operate from './operate';

import './index.less';
import Header from './header';

const DesignSvg = () => {
    document.documentElement.setAttribute('class', 'light');
    return (
        <div className="design-svg">
            <Header />
            <div className="design-svg-editor">
                <Panel />
                <Stage />
            </div>
            {/* <Operate /> */}
        </div>
    );
};
export default DesignSvg;
